import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    // Fns
    this.showBar();
    this._fx();
  }

  _fx() {
    this.animate();
    this.listener();
  }

  animate() {
    this.animation = gsap.timeline();

    this.animation.add([
      gsap.fromTo(
        this.ref.hover,
        {
          transformOrigin: "left top",
          scaleY: 1,
        },
        {
          scaleY: 0,
          duration: 1,
          ease: "quint.out",
          stagger: 0.1,
        }
      ),
      gsap.fromTo(
        this.ref.line,
        {
          transformOrigin: "left top",
          scaleX: 0,
        },
        {
          scaleX: 1,
          duration: 1,
          ease: "quint.out",
          stagger: 0.1,
        }
      ),
      gsap.fromTo(
        this.ref.date,
        {
          y: 15,
        },
        {
          y: 0,
          duration: 1,
          ease: "quint.out",
          stagger: 0.1,
        }
      ),
      gsap.fromTo(
        this.ref.projectName,
        {
          y: 15,
        },
        {
          y: 0,
          duration: 1,
          ease: "quint.out",
          stagger: 0.1,
        }
      ),
      gsap.fromTo(
        this.ref.projectDesc,
        {
          y: 15,
        },
        {
          y: 0,
          duration: 1,
          ease: "quint.out",
          stagger: 0.1,
        }
      ),
    ]);
  }

  listener() {
    this.stListener = ScrollTrigger.create({
      trigger: this.DOM.view,
      animation: this.animation,
      start: "top 60%",
    });
  }

  showBar() {
    let offset = Env.mobileCSS ? "top 96px" : "top 108px";
    this.sticky = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: offset,
      // markers: true,
      onEnter: () => Env.$html.classList.add("list-above"),
      onLeaveBack: () => Env.$html.classList.remove("list-above"),
    });
  }

  unmount() {
    this.sticky.kill();
  }
}
